import styled from 'styled-components';
import {
  Trigger,
  Icon,
  Content,
  Viewport,
  Item,
  ItemText,
} from '@radix-ui/react-select';

export const SelectRoot = styled.div`
  position: relative;

  /* Hide the native select element that Radix creates for accessibility */
  select[aria-hidden='true'] {
    display: none !important;
  }

  select[tabindex='-1'] {
    position: absolute !important;
    left: -9999px !important;
    top: -9999px !important;
    width: 0 !important;
    height: 0 !important;
    opacity: 0 !important;
    pointer-events: none !important;
  }
`;

export const SelectTrigger = styled(Trigger)`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  border-radius: var(--way-design-borderRadiusDefault);
  padding: 12px 14px;
  font-family: inherit;
  font-size: 14px;
  line-height: 1;
  height: 54px;
  gap: 12px;
  background-color: transparent;
  border: 0.5px solid var(--way-colors-borderColor);
  color: var(--way-colors-calendarInputColor);
  cursor: pointer;
  outline: none;
  transition: all 0.2s ease;
  width: 100%;

  &:hover {
    border-color: var(--way-colors-borderHoverColor);
  }

  &:focus-visible {
    outline: 2px solid var(--way-colors-focusBorderColor);
  }

  &[data-disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &[data-placeholder] {
    color: var(--way-colors-contrastColorShades-60);
  }
`;

export const TriggerContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

export const SelectIcon = styled(Icon)`
  color: var(--way-colors-svgColor);
  border-left: 1px solid var(--way-colors-borderColor);
  padding-left: 8px;
`;

export const SelectContent = styled(Content)`
  overflow: hidden;
  background-color: white;
  border-radius: var(--way-design-borderRadiusDefault);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  z-index: 1000;
  min-width: var(--radix-select-trigger-width);
  max-height: var(--radix-select-content-available-height);
`;

export const SelectViewport = styled(Viewport)`
  padding: 8px 4px;
  background-color: white;

  /* Show vertical scrollbar */
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: var(--way-palette-black-30) transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--way-palette-black-30);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: var(--way-palette-black-50);
  }
`;

export const SelectItem = styled(Item)`
  font-family: inherit;
  font-size: 14px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  margin: 4px;
  position: relative;
  user-select: none;
  cursor: pointer;
  color: #051e39;
  background-color: white;
  transition: all 0.15s ease;
  border: 2px solid transparent;
  touch-action: manipulation;

  &[data-highlighted] {
    background-color: var(--way-palette-black-10);
    color: #051e39;
    border: 2px solid var(--way-colors-focusBorderColor);
  }

  &[data-selected='true'] {
    background-color: var(--way-palette-black-10);
  }

  &[data-disabled] {
    color: var(--way-palette-charcoal-100);
    cursor: not-allowed;
    background-color: white;
    border: 2px solid transparent;
  }
`;

export const SelectItemText = styled(ItemText)`
  flex: 1;
`;
